import React from 'react';

import styles from '../Modal.module.scss';

export const SuccessConfirmModal = () => {
  const { txt } = styles;

  return <p className={txt}>Товары успешно куплены!</p>;
};
